import { OrganizationChartDesignTokens } from '@primeuix/themes/aura/organizationchart';

export const organizationChartTokens: OrganizationChartDesignTokens = {
  root: {
    gutter: '0.75rem',
    transitionDuration: '{transition.duration}',
  },
  node: {
    background: '{content.background}',
    hoverBackground: '{content.hover.background}',
    hoverColor: '{content.hover.color}',
    selectedBackground: '{highlight.background}',
    selectedColor: '{highlight.color}',
    borderColor: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    color: '{content.color}',
    padding: '0.75rem 1rem',
    toggleablePadding: '0.75rem 1rem 1.25rem 1rem',
  },
  nodeToggleButton: {
    background: '{content.background}',
    hoverBackground: '{content.hover.background}',
    hoverColor: '{text.color}',
    borderColor: '{content.border.color}',
    borderRadius: '{organizationchart.node.toggle.button.size} / 2',
    color: '{text.muted.color}',
    size: '1.5rem',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
  },
  connector: {
    color: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    height: '24px',
  },
};
